'use client'
import React, { useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

function TanstackProvider({ children }) {
  // ✅ useState ensures ONE QueryClient instance is created and reused across
  // re-renders. Without this, `new QueryClient()` in the function body creates
  // a fresh empty client on every render, wiping the entire cache.
  const [queryClient] = useState(() =>
    new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 1000 * 60 * 5,   // 5 min — data stays "fresh", no refetch on remount
          gcTime: 1000 * 60 * 30,      // 30 min — unused cache kept in memory
          retry: 1,                     // retry once on failure, not 3 times (default)
          refetchOnWindowFocus: false,  // don't refetch when user switches browser tabs
          refetchOnReconnect: true,     // do refetch when internet reconnects
        },
      },
    })
  )

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  )
}

export default TanstackProvider
